export default "__VITE_ASSET__DZWhhF4c__"